import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { ModalContent, ModalFooter } from '@components/secondary-modal';

const SessionExpirationModal = ({ expiresAt, onContinue = () => {}, onLogout = () => {} }) => {
  // Renderer callback with condition
  const [secondsLeft, setSecondsLeft] = useState(Math.max(0, Math.floor((expiresAt - Date.now()) / 1000)));

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(Math.max(0, Math.floor((expiresAt - Date.now()) / 1000)));
    }, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  // This effect will fire onLogout when secondsLeft reaches 0
  useEffect(() => {
    if (secondsLeft === 0) {
      onLogout();
    }
  }, [secondsLeft, onLogout]);

  const countdownRenderer = ({ minutes, seconds }) => {
    return <span>{minutes > 0 ? `${minutes}:${seconds.toString().padStart(2, '0')}` : `${seconds}`}</span>;
  };

  return (
    <ModalContent title='Session Expiration Warning'>
      <section className='modal-body'>
        <p>
          You're being timed out due to inactivity. Your session will expire in{' '}
          <span style={{ fontWeight: 'bold' }}>
            <Countdown date={expiresAt} renderer={countdownRenderer} />
          </span>{' '}
          seconds. Please choose to stay signed-in or to sign out. Otherwise, you will be signed out automatically.
        </p>
      </section>
      <ModalFooter saveText='Continue session' onSave={onContinue} deleteText='Sign out' onDelete={onLogout} />
    </ModalContent>
  );
};

export default SessionExpirationModal;
